import { IonContent, IonHeader, IonPage, IonGrid, IonRow, IonCol } from '@ionic/react';
import React, { useState } from 'react';
import {isIOS, isAndroid, isMobileSafari, isChrome, isChromium, isEdge, isEdgeChromium, isFirefox, isOpera, isSafari} from 'react-device-detect';
import SignInContainer from '../components/SignInContainer';
import ExitContainer from '../components/ExitContainer';
import WebFooterContainer from '../components/WebFooter';
import MobileWebFooterContainer from '../components/MobileWebFooter';

let initted = false;

const SignIn: React.FC = () => {

  const [wideScreenMode, setWideScreenMode] = useState(false);

  const init = async () => {
    if (!initted) {
      initted = true;
      
      if (window.innerWidth > 800) {
        setWideScreenMode(true);
      }
    }
  }
  init();

  return (
    <IonPage>
      <IonHeader>
        {/* <IonToolbar>
          <IonTitle>Blankw</IonTitle>
        </IonToolbar> */}
      </IonHeader>
      <IonContent>
      <IonGrid className="mainContainerForFooter">
          <IonRow>
          <IonCol className="sideCol" size="1"></IonCol>
            <IonCol className="mainCol" size="10">
              <div className="mainDiv">
                <SignInContainer/>
                <ExitContainer></ExitContainer>
              </div>
            </IonCol>
            <IonCol className="sideCol" size="1"></IonCol>
          </IonRow>
        </IonGrid>
        {/* <br/><br/><br/><br/> */}
        
        {wideScreenMode? (
        <WebFooterContainer></WebFooterContainer>
        ): ((isMobileSafari || isChrome || isChromium || isEdge || isEdgeChromium || isFirefox || isOpera || isSafari) && (isIOS || isAndroid))? (
          <MobileWebFooterContainer></MobileWebFooterContainer>
          ):""}
      </IonContent>
    </IonPage>
  );
};

export default SignIn;
